<template>
  <div class="dialog">
    <div class="card">
      <h1>Edit Device</h1>

      <DeviceForm
        :selectedDevice="selectedDevice"
        @hide-dialog="$emit('hide-device-form')"
        @save-device="updateDevice"
        @delete-device="deleteDevice"
      />
    </div>
  </div>
</template>

<script>
import DeviceForm from './DeviceForm';
import firebase from 'firebase/app'
import 'firebase/database'

export default {
  name: "EditDevice",
  components: {
    DeviceForm
  },
  props: {
    selectedDevice: {
      type: Object,
      required: true
    }
  },
  methods: {
    updateDevice(device) {
      firebase.database().ref(`devices/${device.key}`).update(device)
        .then(() => this.$emit('hide-device-form'))
    },
    deleteDevice(device) {
      const confirm = window.confirm(`Are you sure you want to delete #${device.deviceNumber} - ${device.manufacturer} ${device.model}?`)
      if (confirm) {
        firebase.database().ref(`devices/${device.key}`).remove()
          .then(() => this.$emit('hide-device-form'))
      }
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '../../assets/styles/colors';
@import '../../assets/styles/mixin';
@import '../../assets/styles/dialog';
@import '../../assets/styles/card';
</style>



// WEBPACK FOOTER //
// src/components/device/EditDevice.vue